import { createFileRoute } from "@tanstack/react-router";

import BehaviourOrganizations from "../pages/BehaviourOrganizations";
import BehaviourStudio from "../pages/Rules";
import { useAuth } from "../context/AuthContext";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/behaviour-studio/")({
  component: BehaviourStudioRoute,
});

function BehaviourStudioRoute() {
  const auth = useAuth();
  const isUserAdmin = auth.isAdmin === true;
  const isLimitedAdmin = localStorage.getItem("is_limited_admin") === "true";

  return (
    <RequireAuth page="behaviourStudio">
      {isUserAdmin || isLimitedAdmin ? <BehaviourOrganizations /> : <BehaviourStudio />}
    </RequireAuth>
  );
}
